import React, { useState } from 'react';
import './styles/FAQ.css';

const faqList = [
  {
    question: "Is Tasklio really free?",
    answer: "Yes! Tasklio is 100% free with no hidden fees or premium tiers. We believe task management should be accessible to everyone."
  },
  {
    question: "Do I need to create an account?",
    answer: "Creating an account allows you to access your tasks from any device. We offer a quick signup process, or you can use your Google account to get started immediately."
  },
  {
    question: "How does Tasklio protect my privacy?",
    answer: "Your tasks stay on your device and are never uploaded to any cloud server without your explicit permission. We don't track your usage or collect your data."
  },
  {
    question: "Does Tasklio work offline?",
    answer: "Yes, Tasklio works 100% offline. Your tasks are stored locally on your device so you can access them anytime, anywhere."
  },
  {
    question: "How can I get support or contribute?",
    answer: "You can find help, report issues, or contribute on our GitHub or by checking our documentation."
  }
];

const FAQ = () => {
  const [open, setOpen] = useState(null);

  return (
    <section className="faq-section" id="faq">
      <div className="faq-container">
        <div className="faq-header">
          <div className="faq-badge">FAQ</div>
          <h2>Frequently Asked Questions</h2>
          <p>Find quick answers to common questions about Tasklio</p>
        </div>
        <ul className="faq-list">
          {faqList.map((item, idx) => (
            <li
              className={`faq-item${open === idx ? ' open' : ''}`}
              key={item.question}
              onClick={() => setOpen(open === idx ? null : idx)}
              tabIndex={0}
              onKeyPress={e => {
                if (e.key === 'Enter' || e.key === ' ') setOpen(open === idx ? null : idx);
              }}
              aria-expanded={open === idx}
            >
              <div className="faq-question">
                {item.question}
                <span className="faq-toggle">{open === idx ? '−' : '+'}</span>
              </div>
              <div className="faq-answer" style={{ maxHeight: open === idx ? 200 : 0 }}>
                <p>{item.answer}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FAQ;
